import ReadOnlyRecipientViewState from 'owa-readonly-recipient-well/lib/store/schema/ReadOnlyRecipientViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';

export default function mergeReadWriteRecipientWellIntoReadOnly(
    readWriteRecipientWell: RecipientWellWithFindControlViewState,
    readOnlyRecipientArray: ReadOnlyRecipientViewState[]
) {
    if (readWriteRecipientWell && readWriteRecipientWell.recipients) {
        for (const recipient of readWriteRecipientWell.recipients) {
            readOnlyRecipientArray.push({ email: recipient.persona.EmailAddress });
        }
    }
}
